import React, { useEffect, useState } from "react";
import ItemsPage from "../../../../entities/DashboardPage/AccountingModule/Items";
import LoaderHelper from "../../../../utils/Loader/LoaderHelper";
import AuthService from "../../../../api/AuthService";

const Items = () => {
  const [data, setData] = useState();
  const [totalCount, setTotalCount] = useState();
  const [page, setPage] = useState();

  useEffect(() => {
    getAllItems("", "", page);
  }, [page]);

  const getAllItems = async (txt, sort, page) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getItemsList(txt, sort, page);
      if (result?.success) {
        setData(result?.data?.items);
        setTotalCount(result?.data?.total);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleDelete = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.deleteItems(id);
      if (result?.success) {
        getAllItems()
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleSort = (text, sort) => {
    sort ?
      getAllItems("", sort) : text ? getAllItems(text) : null;
  }
  
  return (
    <ItemsPage data={data} page={page} setPage={setPage} totalCount={totalCount} handleDelete={handleDelete} handleFilter={handleSort} hhandleSort={handleSort} />
  )

}

export default Items;
